export default __webpack_public_path__ + "static/discord-110db38c191ec966c149e971a6622253.png";